import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.skills')
  .factory('$skills', skillsObjectFactory);

/* @ngInject */
function skillsObjectFactory($bringozFactory: $bringozFactory,
                             SkillsAPI: BringozApi,
                             Skills_DS: DataStoreConfig) {
  function $skills(id: string) {
    return $bringozFactory(id, SkillsAPI, Skills_DS)
  }

  return $skills;
}
